/**
 * Loading State Reducer
 * Manages all loading and status states
 */

export const loadingStateActions = {
    SET_LOADING: 'SET_LOADING',
    SET_ALL_LOADING: 'SET_ALL_LOADING',
};

const initialState = {
    isSubmitLoading: false,
    isUpdating: false,
    isCategoryLoading: false,
    isUserLoading: false,
};

export const loadingStateReducer = (state, action) => {
    switch (action.type) {
        case loadingStateActions.SET_LOADING:
            return {
                ...state,
                [action.field]: action.value,
            };
        
        case loadingStateActions.SET_ALL_LOADING:
            return {
                ...state,
                ...action.loadingStates,
            };
        
        default:
            return state;
    }
};

